<div class="row">
  <div class="col-12 col-lg-8">
    <div class="row">
      <div class="col-lg-1 hidden-md-down"></div>
      <div class="col-12 col-lg-10">
        <h3 class="page-title" [attr.data-test]="'title-1stDetailsPage'">
          {{ 'checkout-delivery-details.title' | translate }}
        </h3>
        <h6 class="page-subtitle" [attr.data-test]="'subtitle-1stDetailsPage'">
          {{ 'checkout-delivery-details.select-details' | translate }}
        </h6>
        <section class="order-details-form">
          <app-textfield
            label="{{ 'checkout-delivery-details.selected-equipment' | translate }}"
            [form]="orderDetailsForm"
            [modelValue]="orderDetailsForm.value.selectedEquipment"
            [inputName]="'selectedEquipment'"
            [loading]="addressesLoading"
            [readOnly]="true">
          </app-textfield>

          @if (isBusinessPartner) {
            <app-textfield
              label="{{ 'checkout-delivery-details.customer' | translate }}"
              [form]="orderDetailsForm"
              [modelValue]="orderDetailsForm.value.customer"
              [inputName]="'customer'"
              [loading]="addressesLoading"
              [readOnly]="true">
            </app-textfield>
          }

          <app-textfield
            label="{{ 'checkout-delivery-details.sold-to-account' | translate }}"
            [form]="orderDetailsForm"
            [modelValue]="orderDetailsForm.value.soldToAccount"
            [inputName]="'soldToAccount'"
            [loading]="addressesLoading"
            [readOnly]="true">
          </app-textfield>

          @if (isBusinessPartner) {
            <div class="display-flex justify-content-end">
            <a (click)="showModalReportWrongAddress = true;
                   reportWrongAddressType = EAddressType.SOLD_TO;"
                [attr.data-test]="'button-reportWrongSoldToAddress'"
                [title]="'checkout-delivery-details.report-wrong-address-btn' | translate"
                class="report-wrong-address">
                <span class="icon-arrow-right color-orange"></span>
                <span> {{ 'checkout-delivery-details.report-wrong-address-btn' | translate }}</span>
              </a>
            </div>
          }
          <app-select-box
            [form]="orderDetailsForm"
            [modelValue]="orderDetailsForm.value.shipToAddress"
            [options]="availableShipToAddresses"
            [inputName]="'shipToAddress'"
            [loading]="addressesLoading"
            [disabled]="availableShipToAddresses.length < 1"
            [readOnly]="availableShipToAddresses.length <= 1"
            label="{{ 'checkout-delivery-details.ship-to-address' | translate }}"
            [search]="true"
            [searchPlaceholder]="'checkout-delivery-details.search-box-department-placeholder' | translate"
            [attr.data-test]="'checkout-delivery-details-ship-to-addresses-selectbox'"
            (selected)="selectShipToAddressInForm($event)">
          </app-select-box>
          @if (isBusinessPartner) {
            <div class="display-flex justify-content-end">
              <a (click)="showAddNewAddressModal()"
                [attr.data-test]="'button-changeAddress'"
                [title]="'checkout-delivery-details.change-address-btn' | translate"
                class="report-wrong-address padding-right-05"
                [ngClass]="{'disabled': isSaturdayShipment}">
                <span class="icon-arrow-right color-orange"></span>
                <span> {{ 'checkout-delivery-details.change-address-btn' | translate }}</span>
              </a>
            <a (click)="showModalReportWrongAddress = true;
                   reportWrongAddressType = EAddressType.SHIP_TO;"
                [attr.data-test]="'button-reportWrongShipToAddress'"
                [title]="'checkout-delivery-details.report-wrong-address-btn' | translate"
                class="report-wrong-address">
                <span class="icon-arrow-right color-orange"></span>
                <span> {{ 'checkout-delivery-details.report-wrong-address-btn' | translate }}</span>
              </a>
            </div>
          }
          @if (isBusinessPartner) {
            <app-select-box
              [form]="orderDetailsForm"
              [modelValue]="orderDetailsForm.value.businessPartnerBillToAddress"
              [options]="availableBPBillToAddresses"
              [inputName]="'businessPartnerBillToAddress'"
              [loading]="availableBpBillToAddressesLoading"
              [disabled]="availableBpBillToAddressesLoading"
              [readOnly]="availableBPBillToAddresses.length <= 1"
              [search]="true"
              [searchPlaceholder]="'checkout-delivery-details.search-box-department-placeholder' | translate"
              label="{{ 'checkout-delivery-details.bill-to-address' | translate }}"
              (selected)="selectBpBillToAddress($event)">
            </app-select-box>
          }
          @if (isBusinessPartner) {
            <a (click)="showModalReportWrongAddress = true;
                   reportWrongAddressType = EAddressType.BILL_TO;"
              [attr.data-test]="'button-reportWrongBillToAddress'"
              [title]="'checkout-delivery-details.report-wrong-address-btn' | translate"
              class="report-wrong-address">
              <span class="icon-arrow-right color-orange icon"></span>
              <span> {{ 'checkout-delivery-details.report-wrong-address-btn' | translate }}</span>
            </a>
          }
          @if (availableBPBillToAddresses?.length < 1 && isBusinessPartner && !availableBpBillToAddressesLoading) {
            <div class="display-flex">
              <div class="padding-right-05">
                <span class="icon-close icon-close__circle"></span>
              </div>
              <div class="text">
                <span [attr.data-test]="'bill-to-address-error-message'">
                  {{ 'quote-summary.bill-to-error'| translate }}
                </span>
              </div>
            </div>
          }
        </section>
        @if (!isBusinessPartner) {
          <div class="action-buttons-addresses">
            <button type="button"
              class="button button--secondary"
              (click)="showAddNewAddressModal()"
              [attr.data-test]="'button-addNewAddress'"
              [disabled]="isSaturdayShipment">
              {{ 'checkout-delivery-details.add-custom-address-btn' | translate }}
            </button>
            <button type="button"
              class="button button--secondary"
              [disabled]="addressesLoading || orderDetailsForm?.value?.shipToAddress?.value?.isCustom"
              (click)="showModalReportWrongAddress = true"
              [attr.data-test]="'button-reportWrongAddress'">
              {{ 'checkout-delivery-details.report-wrong-address-btn' | translate }}
            </button>
          </div>
        }
        @if (isSaturdayShipment) {
          <p class="disclaimer-saturday-shipment-order-details">
            {{'checkout-delivery-details.saturday-delivery-method-disclaimer' | translate }}
          </p>
        }
        <section class="cart-items">
          <strong class="section-title">
            {{ 'checkout-delivery-details.your-items' | translate }}
          </strong>
          @for (item of cartItemsWithDetails; track item) {
            <div class="cart-item-outer-container">
              <div class="cart-item" [attr.data-test]="'cart-item-' + item.attributes.name">
                <div class="cart-item--image">
                  <img [src]="getProductImageUrl(item)" [alt]="item.attributes.name" [attr.data-test]="'img-itemImage'">
                </div>
                <div class="cart-item--body">
                  <div class="cart-item--info">
                    <div class="info-header">
                      <h5 class="item-name" [attr.data-test]="'desc-itemName'">
                        <a [routerLink]="['/product/', item.attributes.abstractSku]">
                        {{ item.attributes.name || item.attributes.attributes?.sap_name }}</a>
                      </h5>
                      @if ((isProductDiscontinuedStatusEnabled$ | async) && item.attributes.isDiscontinued) {
                        <span
                          class="label discontinued-item"
                          [attr.data-test]="'label-discontinuedItem'">
                          {{ 'spare-parts.discontinued-item' | translate }}
                        </span>
                      }
                      @if (item.attributes.availability?.isExchangeable) {
                        <span
                          class="label item-exchange-material"
                          [attr.data-test]="'label-exchangeableItem'">
                          {{ 'spare-parts.exchangeable-item' | translate }}
                        </span>
                      }
                      @if (item.attributes.heavyweight) {
                        <span
                          class="label heavyweight-item"
                          [attr.data-test]="'label-heavyWeightItem'">
                          {{ 'spare-parts.heavyweight-item' | translate }}
                        </span>
                      }
                    </div>
                    <div class="item-material-number" [attr.data-test]="'desc-materialNumber'">
                      {{ item.attributes.materialNumber }}
                    </div>
                  </div>
                  <div class="cart-item--additional-fields">
                    @for (additionalField of itemDetailsAdditionalFields; track additionalField) {
                      @if (additionalField.shouldDisplayFunc(item)) {
                        <div class="additional-field-row">
                          <div [attr.data-test]="'label-' + additionalField.name">
                            {{ additionalField.name | translate }}:
                          </div>
                          <div [attr.data-test]="'value-' + additionalField.name">
                            {{ additionalField.getValFunc(item) }}
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
              @if (isPriceDisputingActive && isPriceDisputingSetForItem(item.id)) {
                <app-message
                  [message]="itemMessage">
                </app-message>
              }
            </div>
          }
        </section>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-4 order-summary">
    <div class="row">
      <div class="col-12">
        <button type="button"
          class="button button--primary button-next-step"
          [disabled]="!isFormValid()"
          (click)="proceedToContactDetails()"
          [attr.data-test]="'button-proceedToNextStep'">
          {{ 'checkout-delivery-details.next-btn' | translate }}
        </button>
        <section class="cart-pricelist">
          <div class="disclaimer--price">
            <strong [attr.data-test]="'label-totalPrice'">
              {{ 'checkout-delivery-details.total-price' | translate }}
            </strong>
            <br>
            </div>
            <div class="cart--total-price">
              <strong [attr.data-test]="'desc-totalPrice'">
                {{ cartAttributes?.totals?.subtotal | currency: cartAttributes?.currency }}
              </strong>
            </div>
          </section>
          <section>
            <span [attr.data-test]="'label-exclTax'">
              {{ (hasSapDiscounts() ? 'checkout-delivery-details.tax-disclaimer-with-discount' : 'checkout-delivery-details.tax-disclaimer') | translate }}
            </span>
          </section>
          @if (cartRules?.length > 0) {
            <app-cart-rules
              [cartRules]="cartRules"
              [priceToPay]="cartAttributes.totals.priceToPay"
              [currency]="cartAttributes.currency">
            </app-cart-rules>
          }
          <hr class="bottom-line">
          <a class="button button--link button-back-to-cart"
            [routerLink]="['/shop-cart']"
            [attr.data-test]="'link-backToCart'">
            <span class="icon-arrow-left color-orange"></span>
            {{ 'checkout-delivery-details.back-to-cart' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-new-delivery-address-modal
    [showModal]="showModalAddNewAddress"
    (closeModal)="showModalAddNewAddress = false"
    (newAddress)="setCustomShipToAddress($event)">
  </app-new-delivery-address-modal>
  @if (!isBusinessPartner) {
    <app-report-wrong-address-modal
      [userLoggedInRoles]="loggedUserRoles"
      [roleSpecificMessage]="true"
      [addressesList]="this.shipToAddresses"
      [cpqOnly]="true"
      [quoteId]="cartId"
      [resetAddressList]="true"
      [cpqLabelName]="'checkout-delivery-details.ship-to-address' | translate"
      [cpqAddressType]="addressType"
      [functionalLocations]="[systemDetails?.siemensEquipmentId]"
      [showModal]="showModalReportWrongAddress"
      (closeModal)="showModalReportWrongAddress = false">
    </app-report-wrong-address-modal>
  } @else {
    <app-report-wrong-bp-address-modal
      [quoteId]="cartId"
      [addressType]="reportWrongAddressType"
      [functionalLocations]="[systemDetails?.siemensEquipmentId]"
      [showModal]="showModalReportWrongAddress"
      (closeModal)="showModalReportWrongAddress = false; reportWrongAddressType = null"
      [addressValue]="addressValueForReport()"
      [title]="titleForReport()">
    </app-report-wrong-bp-address-modal>
  }
